<!--
  프로필 드롭다운 안에 통합하는 언어 선택 서브메뉴 (2026-07-30).
  상단 헤더의 독립 LangSelector 를 대체 — 반드시 <DropdownMenu> 자식으로 사용.
  기존 LangSelector 의 로직(DB SUPPORTED_LANGUAGES 로드)을 그대로 이식. 국기는 번들 SVG(CountryFlag).
-->
<template>
    <DropdownMenuSub>
        <DropdownMenuSubTrigger class="cursor-pointer">
            <Globe class="mr-2 h-4 w-4" />
            <span>{{ $t('layout.header.dropdown.language') }}</span>
            <span class="ml-2 text-xs text-muted-foreground">{{ currentLangName }}</span>
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent class="w-44">
            <DropdownMenuItem
                v-for="lang in configStore.availableLanguages"
                :key="lang.code"
                @click="setLanguage(lang.code)"
                class="cursor-pointer"
                :class="{ 'bg-accent': lang.code === currentLocale }"
            >
                <CountryFlag
                    :code="languageCountryCode(lang.code)"
                    :alt="lang.langName"
                    size-class="w-5 h-[15px] mr-2"
                />
                {{ lang.langName }}
            </DropdownMenuItem>
        </DropdownMenuSubContent>
    </DropdownMenuSub>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useConfigStore } from '@stores/config';
import { Globe } from 'lucide-vue-next';
import CountryFlag from '@/components/common/CountryFlag.vue';
import { languageCountryCode } from '@/utils/countryFlags';
import {
    DropdownMenuItem,
    DropdownMenuSub,
    DropdownMenuSubTrigger,
    DropdownMenuSubContent,
} from '@/components/ui/dropdown-menu';

const { locale } = useI18n();
const configStore = useConfigStore();

const currentLocale = computed(() => locale.value);

const currentLangInfo = computed(() => {
    const fromActive = configStore.availableLanguages.find(l => l.code === locale.value);
    if (fromActive) return fromActive;
    const fromList = configStore.langList[locale.value] || configStore.langList[configStore.fallbackLang];
    return fromList ? { code: locale.value, ...fromList } : null;
});

const currentLangName = computed(() => currentLangInfo.value?.langName || 'English');

function setLanguage(langCode) {
    locale.value = langCode;
    configStore.setLanguage(langCode);
}

onMounted(async () => {
    await configStore.loadSupportedLanguages();
    const savedLocale = configStore.readSavedLocale();
    const available = configStore.availableLanguages;
    if (available.length === 0) return;
    const nextLocale =
        available.find(l => l.code === savedLocale)?.code
        || available.find(l => l.code === locale.value)?.code
        || available.find(l => l.code === configStore.fallbackLang)?.code
        || available[0].code;
    if (nextLocale !== locale.value) {
        locale.value = nextLocale;
    }
    configStore.setLanguage(nextLocale);
});
</script>
